<div class="level-designer">
  <canvas #designerCanvas class="designer-canvas">
  </canvas>
</div>
